export function createDefaultSubTenantAdminUser(overrides = {}) {
  return {
    firstName: "John",
    lastName: "Doe",
    // admin: true,
    email: "test@accura-tech.com",
    password: "asdf1234",
    matchingPassword: "asdf1234",
    tenantDTO: {
      id: 0,
    },
    roleDTOs: [
      {
        id: 4,
      },
    ],
    subTenantDTO: {
      id: 0,
    },
    ...overrides,
  };
}